import styled, { css } from 'styled-components'

export const FrameFooter = styled.iframe`
  height: 540px;

  @media (max-width: 1170px) {
    height: 230px;
  }
`

export const Wrapper = styled.footer`
  /* ${({ theme }) => css`
    background: ${theme.colors.grey};
    padding: 30px 0;

    @media (max-width: ${theme.media.ipad}) {
      display: none;
    }
  `} */
`

export const FooterWrapper = styled.div`
  margin: auto;
  max-width: 1360px;
  position: relative;
  width: 100%;

  @media (max-width: 1450px) {
    max-width: 95%;
  }
`

export const FooterColumns = styled.div`
  display: block;
  font-size: 0;
  width: 100%;
`

export const FooterColumn = styled.div`
  ${({ theme }) => css`
    display: inline-block;
    width: 20%;
    vertical-align: top;

    @media (max-width: ${theme.media.ipad}) {
      display: none;
    }
  `}
`

export const FooterBox = styled.div`
  padding: 20px;
`

export const FooterTitle = styled.h3`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #8f8f8f;
`

export const FooterList = styled.ul``

export const FooterListItem = styled.li`
  ${({ theme }) => css`
    margin-bottom: 12px;

    a {
      font-size: 14px;
      transition: all 400ms;
      cursor: pointer;

      &:hover {
        color: ${theme.colors.primary};
      }
    }
  `}
`

export const FooterSocialMediaItem = styled.ul`
  display: inline-block;
  margin: 5px 10px 5px 0;

  a {
    transition: all 400ms;

    &:hover {
      opacity: 0.5;
    }
  }
`

export const FooterInformations = styled.div`
  padding: 0 20px;

  p {
    color: #8f8f8f;
    margin-bottom: 10px;
    font-size: 14px;
  }

  strong {
    margin-right: 10px;
  }
`
export const FooterImage = styled.img`
  width: 100%;
`
